import { render } from "./CollaboratorDetail.vue?vue&type=template&id=62d5e4d6&scoped=true"
import script from "./CollaboratorDetail.vue?vue&type=script&lang=js"
export * from "./CollaboratorDetail.vue?vue&type=script&lang=js"

import "./CollaboratorDetail.vue?vue&type=style&index=0&id=62d5e4d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d5e4d6"]])

export default __exports__